import { Card, CardActionArea, Container, Dialog, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, makeStyles, Slide, Typography } from "@material-ui/core";
import { blueGrey, purple } from "@material-ui/core/colors";
import { Clear, Email, Event, LocationOnOutlined, Phone, RemoveRedEyeOutlined } from "@material-ui/icons";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withFirebase } from "../Firebase";
import Footer from "../Footer";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FirstFormationCard = ({ workshopData, workshop }) => {
  const [openDetails, setOpenDetails] = useState(false);
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  const placeLink =
    "https://www.google.com/maps/place/Fagor+Ederlan+S.+Coop./@43.0266997,-2.5107697,18z/data=!4m5!3m4!1s0xd4fd71b96b6aa19:0xc73634e07cb58f86!8m2!3d43.0270702!4d-2.5105408";

  const checkRunningOnMobile = () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    return regexp.test(details);
  };

  if (workshopData?.titles !== undefined) {
    return (
      <Grid item xs={12}>
        <Card style={{ padding: 16 }}>
          <Grid container direction="column">
            <Grid item xs={12}>
              <Typography variant="h5">{workshopData.titles[i18n.language.split("-")[0]]}</Typography>
            </Grid>
            <Grid item xs={12} container>
              <Grid item xs={9} container direction="column">
                <Typography variant="body1">
                  {t("formationPlace")}: {workshopData.formationGroups[workshop].mainPlace}
                </Typography>
                <Typography variant="body1">
                  {t("fecha_de_la_formación")}: {moment(workshopData.formationGroups[workshop].time).format("dddd DD MMMM HH:MM")}
                </Typography>
              </Grid>
              <Grid item xs={3} container justify="flex-end">
                <IconButton onClick={() => setOpenDetails(true)}>
                  <RemoveRedEyeOutlined />
                </IconButton>
              </Grid>
            </Grid>

            <Dialog fullScreen open={openDetails} TransitionComponent={Transition}>
              <div className={classes.mainContainer}>
                <IconButton
                  size="medium"
                  style={{ position: "absolute", top: 19, left: 19, backgroundColor: "rgba(158, 158, 158,0.4)", zIndex: 70 }}
                  onClick={() => setOpenDetails(false)}
                >
                  <Clear style={{ color: "white" }} />
                </IconButton>
                <Grid container justify="center">
                  <Grid item xs={12} md={10} lg={6}>
                    <Grid container spacing={2}>
                      <Grid container item xs={12}>
                        <Typography variant="h2" className={classes.mainTitle}>
                          {workshopData.titles[i18n.language.split("-")[0]]}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Card className={classes.mainCard}>
                          <Grid item container spacing={3}>
                            <Grid item xs={12} style={{ padding: "2px 0px" }}>
                              <ListItem onClick={() => {}}>
                                <ListItemIcon>
                                  <LocationOnOutlined />
                                </ListItemIcon>
                                <ListItemText
                                  primary={t("formationPlace")}
                                  secondary={`${workshopData.formationGroups[workshop].mainPlace}, ${workshopData.formationGroups[workshop].locationDetail}`}
                                />
                              </ListItem>
                            </Grid>

                            <Grid item xs={12} style={{ padding: "2px 0px" }}>
                              <ListItem>
                                <ListItemIcon>
                                  <Event />
                                </ListItemIcon>
                                <ListItemText primary={t("fecha_de_la_formación")} secondary={moment(workshopData.formationGroups[workshop].time).format("LLLL")} />
                              </ListItem>
                            </Grid>

                            <Grid item xs={12} style={{ padding: "2px 0px" }}>
                              <ListItem
                                onClick={() => {
                                  checkRunningOnMobile()
                                    ? window.open("mailto:comercial@bexencardio.com&subject=Formación cardio-protección")
                                    : window.open("https://mail.google.com/mail/?view=cm&source=mailto&to=comercial@bexencardio.com&subject=Formación cardio-protección");
                                }}
                              >
                                <ListItemIcon>
                                  <Email />
                                </ListItemIcon>
                                <ListItemText primary={t("contact")} secondary="info@bexencardio.com" />
                              </ListItem>
                            </Grid>

                            <Grid item xs={12} style={{ padding: "2px 0px" }}>
                              <ListItem onClick={() => checkRunningOnMobile() && window.open("tel:+34943170220")}>
                                <ListItemIcon>
                                  <Phone />
                                </ListItemIcon>
                                <ListItemText primary="+34 943 17 02 20" />
                              </ListItem>
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
              <div style={{ position: "absolute", bottom: 0 }}>
                <Footer />
              </div>
            </Dialog>
          </Grid>
        </Card>
      </Grid>
    );
  } else {
    return <></>;
  }
};

export default withFirebase(FirstFormationCard);

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    [theme.breakpoints.up("sm")]: {
      background: `linear-gradient( #9933CC 0 30vh, transparent 30vh 100%)`,
      minHeight: "100vh",
    },
    [theme.breakpoints.down("sm")]: {
      background: `linear-gradient( #9933CC 0 40vh, transparent 40vh 100%)`,
      minHeight: "100vh",
    },
  },
  mainTitle: {
    letterSpacing: 0,
    color: blueGrey[50],
    marginBottom: 8,
    marginLeft: 19,
    [theme.breakpoints.up("sm")]: {
      font: "400 40px/50px Google Sans,Arial,sans-serif",
      paddingRight: 25,
      top: "21vh",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "10vh",
      font: "400 30px/40px Google Sans,Arial,sans-serif",
      marginBottom: theme.spacing(2),
    },
  },
  mainCard: {
    [theme.breakpoints.up("sm")]: {},
    [theme.breakpoints.down("sm")]: {
      borderRadius: 19,
      boxShadow: "none",
      padding: "38px 16px",
    },
  },
}));
